// Images
import {ONBOARDING_CARD, ONBOARDING_ENGAGE, ONBOARDING_SHOP, RETAILER_NAME} from "../../retailerValues";

const tutorialData = [
  {
    title: 'INTERACT',
    text: `Watch short videos or answer questions to earn savings and rewards`,
    imgUrl: ONBOARDING_ENGAGE
  },
  {
    title: 'LOAD TO CARD',
    text: 'At $1, $3, $6, or $9, savings may be transferred to your Loyalty Card',
    imgUrl: ONBOARDING_CARD
  },
  {
    title: 'SAVE',
    text: `Apply Savings to your store order by presenting your Loyalty Card at checkout`,
    imgUrl: ONBOARDING_SHOP
  }
];

export default tutorialData;



// WEBPACK FOOTER //
// ./src/pages/data/waysToSave.js